module.exports = __webpack_public_path__ + "static/digital_transformation-5812a62950f24f2058d48f3ad3466676.png";